<template>
  <div class="l-container--width-80">
    <v-overlay :model-value="showOverlay">
      <v-progress-circular color="background" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <h1 class="text-left" :class="{ 'c-text--mobile-h1': $vuetify.display.mobile }">
      {{ route.params.domain ? route.params.domain.toUpperCase() : '' }} Evaluations
    </h1>
    <v-row>
      <v-col cols="6" align="left">
        <disclaimer />
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-card
        class="pa-2 ma-4"
        v-for="evaluation in evaluations"
        :key="evaluation.display_name"
        outlined
        tile
        color="background"
      >
        <h3 >{{ evaluation.display_name }}</h3>
        <v-img :src="$imageSrc + evaluation.logo" height="250" max-width="290" contain> </v-img>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn :to="evaluation.actions[0].link" text>
            {{ evaluation.actions[0].action }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :to="evaluation.actions[1].link" text>
            {{ evaluation.actions[1].action }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import Disclaimer from "./Disclaimer.vue";
import { getDomainFromURL, getURLFromDomain } from "../mixins";
import { useRoute, useRouter } from "vue-router";

export default {
  name: 'ViewAllEvaluations',
  components: {
    Disclaimer
  },
  data: () => ({
    evaluations: [],
    showOverlay: true,
    domain: '',
    urlDomain: '',
    route: undefined,
  }),
  watch: {
    'route.path'() {
      // Detect route changes to flip between ICS/Enterprise Evaluations pages
      this.domain = getDomainFromURL(this.route.params.domain).domain;
      this.urlDomain = getURLFromDomain(this.domain).urlDomain;
      this.getEvaluations();
    },
  },
  methods: {
    getActions(evaluation) {
      return [
        {
          action: evaluation.status == 'PUBLISHED' ? 'Results' : 'Participants',
          link:
            evaluation.status == 'PUBLISHED'
              ? `/${this.urlDomain}/participants/?adversaries=${evaluation.name}`
              : `/${this.urlDomain}/${evaluation.name}/#participants`,
        },
        {
          action: 'Overview',
          link: `/${this.urlDomain}/${evaluation.name}/`,
        },
      ];
    },
    getEvaluations() {
      this.$api
        .get(`adversaries/?domain=${this.domain}`)
        .then((response) => {
          if (!response.data.length) this.$handleNotFound();

          this.evaluations = [];
          for (const evaluation of response.data) {
            this.evaluations.push({
              display_name: `${evaluation.display_name} (${evaluation.start_year})`,
              logo: evaluation.logo_image,
              actions: this.getActions(evaluation),
            });
          }
          this.showOverlay = false;
        })
        .catch((err) => {
          console.error(err);
          this.$handleNotFound();
        });
    },
  },
  beforeMount() {
    this.router = useRouter();
    this.route = useRoute();
    if (getDomainFromURL(this.route.params.domain)){
      this.domain = getDomainFromURL(this.route.params.domain).domain;
      this.urlDomain = getURLFromDomain(this.domain).urlDomain;
      this.getEvaluations();
    }
    else {
      this.router.push('/404');
    }

  },
};
</script>
